import React from 'react'
import classNames from 'classnames'

import { Radio } from '@/components/forms/Checkbox'
import { ErrorMessage } from '@/components/forms/ErrorMessage'
import { FormField } from '@/components/forms/FormField'

import { getFieldErrorMessage } from './formik.helpers'

export const RadioGroup = ({
  label,
  field: { name, value, ...fieldProps },
  form: { touched, errors, setFieldValue },
  required,
  options,
  inline = true,
  radioType,
  showError,
  onChange: customOnChange,
  ...props
}) => {
  const error = getFieldErrorMessage({ errors, touched, name })

  let groupClassName = inline ? 'field-row compact' : 'field-stack'
  if (radioType === 'button') {
    groupClassName = 'radio-button-container'
  }

  const handleChange = (_e, data) => {
    const newValue = data?.value
    setFieldValue(name, newValue)

    if (customOnChange) {
      customOnChange(newValue, data)
    }
  }

  const group = (
    <div className={groupClassName}>
      {options.map((option) => {
        return (
          <FormField key={option.value}>
            <Radio
              id={`${name}-${option.value}`}
              label={option.text || option.label}
              value={option.value}
              checked={option.value === value}
              disabled={option.disabled}
              name={name}
              data-testid={`radioGroup-${option.value}`}
              className={classNames({ 'radio-button': radioType === 'button' })}
              {...fieldProps}
              {...props}
              onChange={handleChange}
            />
          </FormField>
        )
      })}
    </div>
  )

  if (!label) {
    return group
  }

  return (
    <FormField required={required} error={Boolean(error)}>
      <label>{label}</label>
      {error && <ErrorMessage content={error} />}
      {group}
    </FormField>
  )
}
